import { withTranslation } from "react-i18next";
import { useTranslation } from "react-i18next";

function Footer({className = ''}) {
    const { t, i18n } = useTranslation();


    return (
        <footer className={`${className}`}>
            <img src={"/assets/img/logoblanco.png"} alt={""} width={216} height={40}/>
            <div className={"footer-text"}>
                <p>{t("footer.copyright")}&nbsp;</p>
                <p><span className={"is-desktop"}>{t("footer.investigator")}&nbsp;</span>{t("footer.address")}&nbsp;
                    <a href={"tel:+34917343950;2511"} title={t("footer.title.tel")}>{t("footer.tel")}</a>&nbsp;
                    <a href={"mailto:ai.orion@upcomillas.es"} title={t("footer.title.email")}>{t("footer.email")}</a>
                </p>
            </div>
        </footer>);
}
export default withTranslation()(Footer);

